<template>
  <AhaInfoBox>
    Please note: This question is not scored. You can convert it into a Quiz slide by
    <a class="right-col--link" @click="activeTabSlide(1)">changing its Type</a>.
  </AhaInfoBox>
</template>

<script>
export default {
  methods: {
    activeTabSlide(index) {
      this.$store.dispatch('updateSlideActive', {
        activeTab: index,
      })
    },
  },
}
</script>
